import { render, staticRenderFns } from "./EmployeeEditButton.vue?vue&type=template&id=6d0b1301&functional=true&"
import script from "./EmployeeEditButton.vue?vue&type=script&lang=ts&"
export * from "./EmployeeEditButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports